import React from 'react';

/**
 * AppLayout Component
 *
 * Top-level layout wrapper that switches between Desktop and Mobile layouts
 * based on screen size using CSS media queries.
 */
const AppLayout = ({ children }) => {
  return (
    <>
      <style>{`
        @media (max-width: 1024px) {
          .desktop-layout {
            display: none !important;
          }
          .mobile-layout {
            display: flex !important;
          }
        }
        @media (min-width: 1025px) {
          .desktop-layout {
            display: flex !important;
          }
          .mobile-layout {
            display: none !important;
          }
        }
      `}</style>
      {children}
    </>
  );
};

export default AppLayout;
